import React, { useEffect, useState } from "react";
import PageLayout from "@/pages/PageLayout";
import ViewSchemaTable from "@/components/DGS/Gridspertise/SchemaTable/ViewSchemaTable";

export default function DatabaseViewer() {
  return (
    <PageLayout>
      <div className="flex flex-col justify-center h-full w-full">
        <div className="py-2 bg-white border border-primary rounded-md mb-4 px-4 text-gray-600">
          <h1 className="text-2xl font-bold">Database Schema Viewer</h1>
          <p>
            Explore the database schemas including tables, columns, data types.
          </p>
        </div>
        <ViewSchemaTable />
      </div>
    </PageLayout>
  );
}
